<div class="card" *ngIf="isAdministrative">
  <div class="card-header">
    <h1 class="h4 text-primary">Configuración Bodegas Administrativas y Fiscales</h1>
    <p class="text-muted mb-0">
      Selecciona la bodega administrativa que se relaciona con cada bodega fiscal.
    </p>
  </div>
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-bordered table-hover align-middle">
        <thead class="table-light">
          <tr>
            <th colspan="4" class="text-center text-danger">Bodegas Fiscales</th>
            <th class="text-center text-primary">Bodegas Administrativas</th>
          </tr>
          <tr>
            <th class="text-center">Código</th>
            <th>Nombre</th>
            <th>Dirección</th>
            <th>Empresa</th>
            <th class="text-center">Bodega Administrativa Relacionada</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let fiscal of warehousesFiscales">
            <td class="text-center">{{ fiscal.code }}</td>
            <td>{{ fiscal.name }}</td>
            <td>{{ fiscal.address || 'Sin dirección' }}</td>
            <td>{{ fiscal.companyName }}</td>
            <td>
              <select class="form-select"
                      [(ngModel)]="fiscal.warehouseAdminId"
                      (change)="onAdminWarehouseSelected(fiscal)">
                <option [ngValue]="null">-- Seleccionar --</option>
                <option *ngFor="let admin of warehousesAdministrative" [ngValue]="admin.id">
                  {{ admin.name }} ({{ admin.code }})
                </option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-3 text-end">
      <button class="btn btn-success" (click)="associateCompanies()">
        <i class="fa fa-save me-2"></i>Guardar relaciones
      </button>
    </div>
  </div>
</div>

<div class="card" *ngIf="!isAdministrative">
  <div class="card-header">
    <h1 class="h4 text-danger">Configuración Bodegas Administrativas y Fiscales</h1>
  </div>
  <div class="card-body">
    <div class="alert alert-warning">
      Para configurar bodegas necesitas estar en una empresa <strong>administrativa</strong>.
    </div>
  </div>
</div>
